import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from './../store';

const examplePreferences = [
	{
		id: 1,
		name: 'Beverage',
		amount: 15,
		counter: 0,
	},
	{
		id: 2,
		name: 'Half Bread',
		amount: 10,
		counter: 50,
	},
	{
		id: 3,
		name: 'Full Bread',
		amount: 15,
		counter: 0,
	},
];

const initialState = {
	preferences: [],
	loading: true,
} as any;

export const fetchPreference = createAsyncThunk(
	'Profile/FetchPreference',
	async (_) => {
		// const response = await fetch(
		// 	'https://jsonplaceholder.typicode.com/users?_limit=5'
		// );
		// const data = await response.json();
		// return data;
		return examplePreferences;
	}
);

const preferenceSlice = createSlice({
	name: 'preference',
	initialState,
	reducers: {
		increment: (state, action) => {
			state.preferences.find(
				(preference: any) => preference.id === action?.payload
			).counter++;
		},
		decrement: (state, action) => {
			state.preferences.find(
				(preference: any) => preference.id === action?.payload
			).counter--;
		},
		submit: (state) => {
			state.loading = true;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPreference.fulfilled, (state, action) => {
			state.loading = false;
			state.preferences = action?.payload;
		});

		builder.addCase(fetchPreference.pending, (state, _) => {
			state.loading = true;
		});
	},
});

export const { increment, decrement, submit } = preferenceSlice.actions;
export const selectPreference = (state: RootState) => state.preference;

export default preferenceSlice.reducer;
